// extracted by mini-css-extract-plugin
export default {"figure":"figure-Kv47Z","skeleton":"skeleton-M6sUh"};